import { actionCreator } from 'utils';
import {
    LOAD_MACHINES,
    SET_EMPTY_EDITABLE_MACHINE,
    LOAD_EDITABLE_MACHINE,
} from '../types/machineTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    listing: {},
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_MACHINES:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(LOAD_MACHINES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_MACHINES, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case LOAD_EDITABLE_MACHINE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITABLE_MACHINE, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITABLE_MACHINE, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case SET_EMPTY_EDITABLE_MACHINE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    default:
        return state;
    }
}
